import React, { Fragment } from "react";

import ErrorIcon from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";

import Button from "@src/multiCustodian/components/MUI/Button/Button";
import Switch from "@src/sharedComponents/Switch/Switch";
import EmptyTable from "@src/sharedComponents/Table/EmptyTable";
import Text from "@src/sharedComponents/Typography/Text";

import Footer, { FooterProps } from "./Footer";
import Header from "./Header";

import styles from "./DoNotSellModal.module.css";

type NoDataProps = React.PropsWithChildren<{} & FooterProps>;

const NoDataExclusions: React.FC<NoDataProps> = (props) => {
  return (
    <>
      <Header
        tradingGroupName="Trading Group Name"
        markAllSecurities={() => undefined}
        unmarkAllSecurities={props.onCloseModal}
        inputValue=""
        setInputValue={() => undefined}
      />
      <EmptyTable
        emptyRows={10}
        emptyCell={<Switch onClick={() => {}} on={false} disabled={true} />}
        columns={["Security", "Account", "Quantity", "Value", "Do not sell"]}
        noBorderRadius
      >
        <div className={styles.emptyTable}>{props.children}</div>
      </EmptyTable>
      <Footer
        onConfirm={() => undefined}
        onCloseModal={props.onCloseModal}
        isMutating={false}
        numberChanges={0}
      />
    </>
  );
};

export const EmptyState = (props: NoDataProps) => (
  <NoDataExclusions {...props}>
    <Text variant="body" color="textSubtle">
      No data to show
    </Text>
  </NoDataExclusions>
);

export const ErrorState = (props: NoDataProps) => (
  <NoDataExclusions {...props}>
    <div className={styles.errorStateWrapper}>
      <div className={styles.errorText}>
        <ErrorIcon
          color={"disabled"}
          className={styles.icon}
          width={"14px"}
          height={"14px"}
        />
        <Text variant="body" color="textSubtle">
          Error loading table
        </Text>
      </div>
      <Button
        buttonType="secondary"
        text="Retry"
        variant="outlined"
        onClick={() => undefined}
        size="small"
        endIcon={<RefreshIcon className={styles.icon} />}
      />
    </div>
  </NoDataExclusions>
);
